// periodHelper.js or top of your Orders component
export function getPeriodRange(period) {
  const now = new Date();
  let start, end;
  end = new Date(); // default is now

  switch (period) {
    case "Today":
      start = new Date();
      start.setHours(0, 0, 0, 0);
      break;
    case "Yesterday":
      start = new Date();
      start.setDate(now.getDate() - 1);
      start.setHours(0, 0, 0, 0);
      end = new Date(start);
      end.setHours(23, 59, 59, 999);
      break;
    case "7d":
      start = new Date();
      start.setDate(now.getDate() - 7);
      break;
    case "30d":
      start = new Date();
      start.setDate(now.getDate() - 30);
      break;
    case "3m":
      start = new Date();
      start.setMonth(now.getMonth() - 3);
      break;
    case "6m":
      start = new Date();
      start.setMonth(now.getMonth() - 6);
      break;
    case "12m":
      start = new Date();
      start.setMonth(now.getMonth() - 12);
      break;
    default:
      start = new Date(2000, 0, 1);
  }
  return {
    startTime: start.toISOString(),
    endTime: end.toISOString(),
  };
}